export default "__VITE_PUBLIC_ASSET__abbf6e08__"